import { graphql } from '@/gql';

export const STANDORT_BY_ID = graphql(`
  query dienstplan_standortById($standortId: String!) {
    dienstplan_findStandortById(standortId: $standortId) {
      tageswechsel
    }
  }
`);
